
import { StorageService } from './storage.js';
const locale = StorageService.getLocale() || process.env.VUE_APP_LOCALE;
// Solo se descarga el idioma activo; `messages` se llena en sitio para que
// las referencias existentes (i18n.messages, t) sigan vigentes.
const messages = {};

async function loadLocale() {
  let data;
  try {
    data = await import(/* webpackChunkName: "i18n-[request]" */ `src/i18n/${locale}.json`);
  }
  catch (err) {
    console.error(err);
    //fallback locale
    try {
      data = await import(/* webpackChunkName: "i18n-en-US-json" */ `src/i18n/en-US.json`);
    }
    catch (fallbackErr) {
      // Sin traducciones la app sigue montando: t() devuelve la llave.
      console.error(fallbackErr);
      return;
    }
  }
  Object.assign(messages, data.default || data);
}

const i18n = {
  locale,
  messages,
  t: function (key, args) {
    let value = key.split('.').reduce((p, c) => p?.[c], messages);
    if (value && args) {
      const names = Object.keys(args);
      const vals = Object.values(args);
      return new Function(...names, `return \`${value}\`;`)(...vals);
    }
    return value || key;
  }
};

const $t = i18n.t;
export { i18n, $t, loadLocale }
